<div class="modal" cdkScrollable>
  <header class="modal__header">
    <h2 class="modal__header__title">
      <ng-container *ngIf="!editMode; else editAbsenceLabel">
        <span translate>Add absence</span>
      </ng-container>

      <ng-template #editAbsenceLabel>
        <span translate>Edit absence</span>
      </ng-template>
    </h2>

    <button class="modal__header__close" (click)="_dialogRef.close()">
      <i class="icon icon-close_ico"></i>
    </button>
  </header>

  <div class="modal__content create-content">
    <ng-container *rxIf="absenceItem.loading$; let loading">
      <loader [loading]="loading"></loader>
    </ng-container>

    <ng-container *ngIf="(editMode && !(absenceItem.loading$ | push: 'global')) || !editMode">
      <form class="absence-form" [formGroup]="form">
        <div class="control-container form-group py-0" appFormControlError="is_vacation">
          <div class="control-label">
            <span translate>Reason</span>
            <span class="control-required">*</span>
          </div>

          <app-select
            valueKey="value"
            displayKey="name"
            formControlName="is_vacation"
            [placeholder]="'Select reason' | translate"
            [disabled]="editMode"
            [model]="reasonModel"
            [withNone]="false"
            [optionList]="ABSENCE_REASON_OPTIONS_LIST"
            (selectedValue)="changeReason($event)">
          </app-select>
        </div>

        <ng-container>
          <div class="control-container form-group py-0" appFormControlError="userId">
            <div class="control-label">
              <span translate>Employee</span>
              <span class="control-required">*</span>
            </div>

            <app-select
              valueKey="id"
              displayKey="full_name"
              formControlName="userId"
              [placeholder]="'Select' | translate"
              [disabled]="editMode || !isAdmin"
              [withNone]="false"
              [model]="employeeModel"
              [collection]="employeesCollection"
              [optionList]="employeesCollection.items"
              (refreshCallback)="getEmployeesList($event)"
              (selectedValue)="handleSelect($event)">
            </app-select>
          </div>
        </ng-container>

        <div *ngIf="!isVacation" class="control-container form-group py-0" appFormControlError="absenceCategory">
          <div class="control-label">
            <span translate>Absence Type</span>
            <span class="control-required">*</span>
          </div>

          <app-select
            valueKey="id"
            displayKey="name"
            fieldKey="id"
            [placeholder]="'Select Absence Type' | translate"
            formControlName="absenceCategory"
            [withNone]="false"
            [disabled]="form.get('absenceCategory')?.disabled"
            [model]="absenceTypeModel"
            [collection]="absenceTypeCollection"
            [optionList]="absenceTypeCollection.items"
            (refreshCallback)="getAbsenceTypeList($event)"
            (selectedValue)="changeAbsenceType($event)">
          </app-select>
        </div>

        <div class="row">
          <div class="control-container form-group py-0" appFormControlError="startDate">
            <div class="control-label">
              <span translate>From</span>
              <span class="control-required">*</span>
            </div>

            <app-datepicker
              [date]="form.get('startDate').value"
              (ngModelChange)="changeFrom($event)"
              formControlName="startDate"
              [height]="'32px'">
            </app-datepicker>
          </div>

          <div class="control-container form-group py-0" appFormControlError="endDate">
            <div class="control-label">
              <span translate>To</span>
              <span class="control-required">*</span>
            </div>

            <app-datepicker
              [date]="form.get('endDate').value"
              (ngModelChange)="changeTo($event)"
              formControlName="endDate"
              [height]="'32px'">
            </app-datepicker>
          </div>
        </div>

        <div *ngIf="!isVacation && isSameDate()" class="row">
          <div class="control-container form-group py-0" appFormControlError="startTime">
            <div class="control-label">
              <span translate>From</span>
              <span class="control-required">*</span>
            </div>

            <input appTimeMask class="time-input" formControlName="startTime" />
          </div>

          <div class="control-container form-group py-0" appFormControlError="endTime">
            <div class="control-label">
              <span translate>To</span>
              <span class="control-required">*</span>
            </div>

            <input appTimeMask class="time-input" formControlName="endTime" />
          </div>
        </div>

        <div class="errors-wrap">
          <p class="error">
            {{ form.errors?.message }}
          </p>
        </div>

        <div class="row-days">
          <div class="days-wrapper">
            <span translate>Total</span>

            <span>
              <span class="working-days-wrap">
                <ng-container *rxLet="workingDaysRequest.loading$; let workingDaysRequestLoading">
                  <ng-container *ngIf="!workingDaysRequestLoading; else workingDaysLoading">
                    <ng-container *ngIf="isSameDate() && !isVacation && selectedTimePeriod; else day">
                      {{ selectedTimePeriod }}

                      <span>{{ 'selected' | translate }}</span>
                    </ng-container>

                    <ng-template #day>
                      {{ selectedDays }}

                      <ng-container *ngIf="selectedDays > 1; else dayWord">
                        <span>{{ 'days' | translate }}</span>
                      </ng-container>

                      <ng-template #dayWord>
                        <span>{{ 'day' | translate }}</span>
                      </ng-template>

                      <span>
                        {{ 'selected' | translate }}
                      </span>
                    </ng-template>
                  </ng-container>

                  <ng-template #workingDaysLoading>
                    <span class="loader small"></span>
                  </ng-template>
                </ng-container>
              </span>

              <ng-container *ngIf="employeeModel && isVacation">
                <span *ngIf="leftDaysInfo">/</span>

                <span>
                  {{ leftDaysInfo.daysLeftNumber }}
                  {{ leftDaysInfo.dayLabel | translate }}
                  {{ leftDaysInfo.leftInLabel | translate }}
                  {{ leftDaysInfo.year }}
                </span>
              </ng-container>
            </span>
          </div>
        </div>

        <div class="control-container form-group py-0" appFormControlError="comment">
          <div class="control-label" translate>Comment</div>
          <textarea class="form-control" formControlName="comment"></textarea>
        </div>
      </form>
    </ng-container>
  </div>

  <div class="modal__actions mt-3 content-footer">
    <ng-container *ngIf="editMode">
      <div class="row-flex mx-0 delete-btn-wrap row-flex--middle">
        <btn-action
          *ngIf="canUpdate()"
          [buttonLabel]="'Delete' | translate"
          [withIcon]="true"
          iconClass="icon-Delete_ico"
          styleClasses="delete"
          (applyAction)="delete()">
        </btn-action>

        <span
          class="icon icon-Question_ico question-mark"
          matTooltip="{{ 'Created' | translate }} {{ absenceItem.data.created_at | formatDate }}">
        </span>
      </div>
    </ng-container>

    <div class="btn-group row-flex row-flex--middle row-flex--end mx-0 w-100">
      <btn-outline class="cancel-btn mr-2" [buttonLabel]="'Cancel' | translate" (applyAction)="_dialogRef.close()"> </btn-outline>

      <ng-container *ngIf="editMode && (canUpdate() || absenceItem?.data?.status === requestStatuses.New)">
        <btn-loader
          styleClasses="btn__primary"
          [buttonLabel]="'Save' | translate"
          [uppercase]="true"
          [loading]="(absenceItem.loadingCrud$ | async).updating"
          (applyAction)="save()"></btn-loader>
      </ng-container>
      <ng-container *ngIf="!editMode">
        <btn-loader
          styleClasses="btn__primary"
          [buttonLabel]="'Save' | translate"
          [uppercase]="true"
          [loading]="(absenceItem.loadingCrud$ | async).creating"
          (applyAction)="save()"></btn-loader>
      </ng-container>
    </div>
  </div>
</div>

<button id="hideButton" (click)="$event.preventDefault()"></button>
